import {inject, Injectable} from "@angular/core";
import {Actions, createEffect, ofType} from "@ngrx/effects";
import {AuditRepository} from "../../../repository/audit.repository";
import {generateAuditAction, getAuditFailureAction, getAuditSuccessAction} from "../audit.actions";
import {catchError, exhaustMap, map, of} from "rxjs";
import {HttpErrorResponse} from "@angular/common/http";

@Injectable()
export class AuditEffect {

  private actions$ = inject(Actions);
  private auditRepo = inject(AuditRepository);

  generateAudit$ = createEffect(() => this.actions$.pipe(
    ofType(generateAuditAction),
    exhaustMap(action => {
      return this.auditRepo.generateAudit().pipe(
        map(response => getAuditSuccessAction({result: response})),
        catchError((errorResponse: HttpErrorResponse) => of(getAuditFailureAction({error: errorResponse})))
      )
    })
  ));
}
